// @flow
/* eslint-disable import/prefer-default-export */

export const MODULE_NAME = 'router';



// WEBPACK FOOTER //
// ./src/modules/router/constants.js